const minHeight = 810;
const desktopWidth = 1080;
const sidebarWidth = 284;
const headerHeight = 100;
const defaultShadow = "0 0 1em rgb(0 0 0 / 15%)";

export { sidebarWidth, headerHeight, minHeight, desktopWidth, defaultShadow };
